/**
 * `paymentKeys` here only carries the `vendor` branch this slice owns.
 * `src/lib/query-keys.ts` composes it with the `customer-payments` branch
 * into the combined shape `portal-payments/utils.ts` needs.
 */
export const paymentKeys = {
  vendor: {
    all: ["vendor-payments"] as const,
    lists: () => [...paymentKeys.vendor.all, "list"] as const,
    list: (filters: Record<string, unknown>) => [...paymentKeys.vendor.lists(), filters] as const,
    totals: (filters: Record<string, unknown>) =>
      [...paymentKeys.vendor.all, "totals", filters] as const,
    details: () => [...paymentKeys.vendor.all, "detail"] as const,
    detail: (id: string) => [...paymentKeys.vendor.details(), id] as const,
    related: (id: string) => [...paymentKeys.vendor.detail(id), "related"] as const,
  },
};
